<template>
  <div>
    <b-field>
      <p v-if="false" class="control">
        <filter-form @filter="handleFormSubmit"></filter-form>
      </p>

      <b-input icon="magnify" type="search" v-model="search" :placeholder="$tc('search.user')" expanded></b-input>
    </b-field>

    <div v-if="form">
      <b-tag v-if="form.status" @close="form.status = null" closable>Төлөв: {{ form.status }}</b-tag>
    </div>
  </div>
</template>

<script>
import Base from "../../../../../components/BaseFilter";
import FilterForm from "./Form";

export default {
  components: {
    FilterForm
  },

  mixins: [Base],

  methods: {
    fresh() {
      return {
        search: null,
        status: null
      };
    },

    parseForm(form) {
      return {
        status: form.status
      };
    }
  }
};
</script>
